import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import faviconIcon from '../assets/images/favicon.png';
import axios from 'axios';
// import { cmsAPI } from '../../api_helper';

const WhyJoinUs = () => {
  const [cmsData, setCmsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fallback data in case API fails
  const fallbackData = {
    heading1: "Why join us",
    heading2: "We unite leaders to create lasting impact",
    description1: "Through trusted relationships and shared insights, we help you advance your vision and strengthen your influence.",
    points: [
      {
        subHeading: 'Private Access',
        description: 'Join invitation-only gatherings with leaders who set the agenda for security and innovation'
      },
      {
        subHeading: 'Collective Insight',
        description: 'Gain perspectives from peers tackling the same challenges and opportunities.'
      },
      {
        subHeading: 'Accelerated Growth',
        description: 'Discover emerging solutions, meet founders, and connect with funding partners.'
      }
    ]
  };

  // Fetch CMS data for "why-join-us" slug
  useEffect(() => {
    const fetchCMSData = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/public/cms/why-join-us');
        
        if (response.isOk && response.data) {
          setCmsData(response.data);
        } else {
          console.warn('No CMS data found for why-join-us slug, using fallback');
          setCmsData(fallbackData);
        }
      } catch (error) {
        console.error('Error fetching CMS data:', error);
        setError(error.message);
        // Use fallback data on error
        setCmsData(fallbackData);
      } finally {
        setLoading(false);
      }
    };

    fetchCMSData();
  }, []);

  // Get current data or fallback
  const currentData = cmsData || fallbackData;

  if (loading) {
    return (
      <section className="py-5 why-join">
        <Container>
          <div className="text-center">
            <div className="d-flex align-items-center justify-content-center">
              <div className="spinner-border text-primary me-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span>Loading content...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  return (
    <section className="py-5 why-join">
      <Container>
        {error && (
          <div className="alert alert-warning mb-4">
            <small>
              <i className="fas fa-exclamation-triangle me-1"></i>
              Unable to load dynamic content. Displaying default content.
            </small>
          </div>
        )}
        
        <p className="why-us-title text-uppercase">
          <span className="section-line"></span> {currentData.heading1 || "Why join us"}
        </p>
        <h2 className="why-us-heading display-5">
          {currentData.heading2 || "We unite leaders to create lasting impact"}
        </h2>
        <p className="why-us-content mx-auto">
          {currentData.description1 || "Through trusted relationships and shared insights, we help you advance your vision and strengthen your influence."}
        </p>

        <Row className="feature-row">
          {(currentData.points || []).map((point, index) => (
            <React.Fragment key={index}>
              <Col sm={7} lg={3} className="feature-box">
                <div className="d-flex align-items-center justify-content-start justify-content-md-center mb-md-3 mb-0">
                  {currentData.image ? (
                    <img 
                      src={cmsAPI.getImageUrl(currentData.image)} 
                      alt="Feature Icon" 
                      className="toggle-icon me-2"
                      onError={(e) => {
                        console.warn(`Failed to load CMS image: ${currentData.image}`);
                        e.target.src = faviconIcon; // Fallback to default icon
                      }}
                    />
                  ) : (
                    <img 
                      src={faviconIcon} 
                      alt="Toggle Icon" 
                      className="toggle-icon me-2" 
                    />
                  )}
                  <h5 className="feature-title mb-0">{point.subHeading}</h5>
                </div>
                <p className="feature-text">
                  {point.description}
                </p>
              </Col>

              {/* Divider - only show between features, not after the last one */}
              {index < currentData.points.length - 1 && (
                <Col md={1} className="d-none d-lg-flex align-items-center justify-content-center">
                  <div className="divider"></div>
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyJoinUs;
